import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../lib/useTheme";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const Icon = theme === "dark" ? Sun : Moon;
  return (
    <button
      type="button"
      onClick={toggle}
      title={theme === "dark" ? "Switch to light" : "Switch to dark"}
      aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
      data-testid="theme-toggle"
      className={`btn btn-secondary btn-sm ${className}`}
    >
      <Icon size={13} strokeWidth={1.8} />
      <span className="hidden md:inline font-mono text-[10px] uppercase tracking-[0.14em]">{theme === "dark" ? "Light" : "Dark"}</span>
    </button>
  );
}
